webpackJsonp([181912564021042],{

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _Help = __webpack_require__(32);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _reactLoadingOverlay = __webpack_require__(30);
	
	var _reactLoadingOverlay2 = _interopRequireDefault(_reactLoadingOverlay);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPassword = function (_React$Component) {
	  _inherits(ForgotPassword, _React$Component);
	
	  function ForgotPassword() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ForgotPassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      username: "",
	      email: "",
	      rememberme: "",
	      action: "",
	      errorMessage: "",
	      message: "",
	      success: false,
	      redirect: "",
	      submited: false,
	      isActive: false,
	      help: ""
	    }, _this.updateUsername = function (event) {
	      _this.setState({ username: event.target.value });
	    }, _this.updateEmail = function (event) {
	      _this.setState({ email: event.target.value });
	    }, _this.postData = function (url) {
	      // Default options are marked with *
	      return fetch(url, {
	        method: "POST", // *GET, POST, PUT, DELETE, etc.
	        mode: "cors", // no-cors, cors, *same-origin
	        //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
	        //credentials: "same-origin", // include, *same-origin, omit
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded"
	          //"Content-Type": "text/html",
	          //"Accept" : "text/html"//,
	          //  "Accept-Encoding": "gzip, deflate"
	        },
	        body: "username=" + _this.state.username + "&email=" + _this.state.email + "&portal=true"
	      }).then(function (response) {
	        return response.json();
	      }); // parses response to JSON
	    }, _this.handleSubmit = function (event) {
	      event.preventDefault();
	      _this.setState({ isActive: true });
	      _this.postData("/wbe/CommandServlet?command=resetPassword").then(function (data) {
	        //console.log(JSON.stringify(data))
	        _this.setState({
	          errorMessage: data.data.errorMessage,
	          message: data.data.message,
	          success: data.data.success,
	          redirect: data.data.redirect,
	          submited: true
	        });
	      });
	      _this.setState({ isActive: false });
	    }, _this.displayMessage = function () {
	      if (_this.state.success) {
	        document.getElementById("password-reset-form").reset();
	        return _react2.default.createElement(
	          "div",
	          { className: "header-form__head" },
	          _react2.default.createElement(
	            "div",
	            { className: "header-form__text" },
	            "A temporary password has been sent to your email. Once you have received it, please click ",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/login" },
	              "here"
	            ),
	            " to log in."
	          )
	        );
	      } else {
	        if (_this.state.submited) {
	          return _react2.default.createElement(
	            "div",
	            { className: "header-form__head" },
	            _react2.default.createElement(
	              "div",
	              { className: "header-form__text" },
	              _react2.default.createElement(
	                "span",
	                { className: "alert-message" },
	                "Username/e-mail does not match our records. Please try again."
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            "div",
	            { className: "header-form__head" },
	            _react2.default.createElement(
	              "div",
	              { className: "header-form__text" },
	              " ",
	              "A temporary password will be sent to your e-mail which you can then use to reset your password."
	            )
	          );
	        }
	      }
	    }, _this.displayHelp = function () {
	      if (_this.state.help === "show") {
	        return _react2.default.createElement(_Help2.default, { id: "help" });
	      };
	    }, _this.toggleHelp = function () {
	      if (_this.state.help === "show") {
	        _this.setState({ help: "hide" });
	      } else {
	        _this.setState({ help: "show" });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ForgotPassword.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactLoadingOverlay2.default,
	        { active: this.state.isActive, spinner: true, text: "Loading..." },
	        _react2.default.createElement(
	          "form",
	          {
	            id: "password-reset-form",
	            name: "forgot",
	            action: this.state.action,
	            onSubmit: function onSubmit(event) {
	              _this2.handleSubmit(event);
	            },
	            method: "post",
	            className: "header-form",
	            style: { marginTop: 50, flexWrap: "wrap", textAlign: "center" }
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "alert-message" },
	            this.state.errorMessage
	          ),
	          this.displayMessage(),
	          _react2.default.createElement(
	            "div",
	            { className: "header-form__inner" },
	            _react2.default.createElement("input", {
	              id: "email",
	              name: "email",
	              type: "email",
	              placeholder: "Email...",
	              className: "c-input header-form__input",
	              tabIndex: "1",
	              style: { order: 1 },
	              required: true,
	              onChange: function onChange(event) {
	                _this2.updateEmail(event);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "header-form__options header-form__options--1" },
	              _react2.default.createElement(
	                "a",
	                { href: "#0", className: "header-form__label", onClick: function onClick() {
	                    _this2.toggleHelp();
	                  } },
	                _react2.default.createElement(
	                  "svg",
	                  {
	                    xmlns: "http://www.w3.org/2000/svg",
	                    viewBox: "0 0 15 15",
	                    width: 15,
	                    height: 15,
	                    fill: "#E21E32",
	                    style: { marginRight: 6 }
	                  },
	                  _react2.default.createElement("path", {
	                    d: "M727.8 1042.6l-.7.4-.8.9.3.2.5-.5.1.1-.1.7-1.1 3.1-.2 1c0 .4.3.6.7.5l.7-.4.6-.7-.3-.3-.4.4-.1-.1.2-.7 1.1-3.1.2-1c-.1-.4-.3-.6-.7-.5zm1.5-1.5c-.2.4-.7.6-1.1.4-.4-.2-.6-.7-.4-1.1.2-.4.6-.5.9-.4.5.2.7.7.6 1.1zm-1.8 9.9a6.5 6.5 0 1 0 0-13 6.5 6.5 0 1 0 0 13m0 1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5z",
	                    transform: "translate(-720 -1037)"
	                  })
	                ),
	                "Help?"
	              )
	            ),
	            _react2.default.createElement("input", {
	              id: "username",
	              name: "username",
	              placeholder: "Username...",
	              className: "c-input header-form__input",
	              tabIndex: "2",
	              style: { order: 3 },
	              required: true,
	              onChange: function onChange(event) {
	                _this2.updateUsername(event);
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "header-form__options header-form__options--2" },
	              _react2.default.createElement(
	                "label",
	                { className: "header-form__label header-form__link" },
	                "Forgot your \xA0",
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/forgotUsername" },
	                  "username"
	                ),
	                "\xA0?"
	              )
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "submit",
	                className: "c-btn c-btn--white header-form__btn",
	                tabIndex: "3"
	              },
	              "Reset",
	              _react2.default.createElement(
	                "svg",
	                {
	                  viewBox: "0 0 30.595 12.238",
	                  width: "24",
	                  height: "11",
	                  fill: "currentColor",
	                  style: { marginLeft: 5 }
	                },
	                _react2.default.createElement(
	                  "g",
	                  { transform: "translate(-5 -22)" },
	                  _react2.default.createElement("path", {
	                    d: "M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z",
	                    transform: "translate(827 -1165.238)"
	                  })
	                )
	              )
	            )
	          )
	        ),
	        this.displayHelp()
	      )
	    );
	  };
	
	  return ForgotPassword;
	}(_react2.default.Component);
	
	exports.default = ForgotPassword;
	module.exports = exports["default"];

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _ForgotPassword = __webpack_require__(179);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Reset Password"
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      "header",
	      {
	        className: (0, _classnames2.default)("c-header", "c-header--full", "t-context--dark", "bg")
	      },
	      _react2.default.createElement(_ForgotPassword2.default, { name: "forgotPassword" })
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forgot-password-js-9b0f9cedc7102dbad483.js